import { Controller } from "@hotwired/stimulus";
import { cable } from "@hotwired/turbo-rails";
import { ignoringBriefDisconnects, countElCreate } from "../helpers/dom_helpers";
const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.content || "";

export default class RoomListController extends Controller {
  static targets = ["list", "count"];
  static classes = ["unread"];
  static values = { roomIds: Array, default: [] };

  #disconnected = true;

  connect() {
    void this.#subscribeToChannel();
  }

  async #subscribeToChannel() {
    this.channel ??= await cable.subscribeTo(
      { channel: "UnreadRoomsChannel" },
      {
        connected: this.#channelConnected.bind(this),
        disconnected: this.#channelDisconnected.bind(this),
        received: this.#unread.bind(this)
      }
    );
  }

  disconnect() {
    ignoringBriefDisconnects(this.element, () => {
      this.channel?.unsubscribe();
      this.channel = null;
    });
  }

  loaded() {
    setTimeout(() => {
      this.read(Current.room.id);
    }, 100);
  }

  read(roomId) {
    const room = this.#findRoomTarget(roomId);
    this.roomIdsValue = this.roomIdsValue.filter(id => id != roomId);
    if (room) {
      room.innerHTML = "";
      let count = $("#message_count .msg_count");
      if (count) {
        const val = this.roomIdsValue.length;
        if (val > 0) {
          count.text(val);
        } else {
          count.remove();
        }
      }
    }
  }

  #channelConnected() {
    if (this.#disconnected) {
      this.#disconnected = false;
      // this.element.reload()
    }
  }

  #channelDisconnected() {
    this.#disconnected = true;
  }

  #unread({ roomId, senderId, scroll }) {
    const unreadRoom = this.#findRoomTarget(roomId);

    if (unreadRoom && Current.user.id != senderId) {
      this.#updateUnreadRoom(roomId, unreadRoom, scroll);
      this.dispatch("unread", { detail: { targetId: unreadRoom.id } });
    }

    this.#moveConversationToTop(roomId);
  }

  #updateUnreadRoom(roomId, unreadRoom, scroll) {
    this.#addRoomId(roomId);

    if (Current?.room?.id != roomId) {
      this.#updateUnreadCounts(unreadRoom);
      return;
    }

    this.#handleActiveRoom(roomId, scroll);
  }

  #addRoomId(roomId) {
    if (this.roomIdsValue.includes(roomId)) return;

    this.roomIdsValue = [...new Set([...this.roomIdsValue, roomId])];
  }

  #updateUnreadCounts(unreadRoom) {
    this.#updateCount(unreadRoom);

    const sidebarMsgCount = document.getElementById("message_count");

    if (!sidebarMsgCount) return;

    this.#updateCount(sidebarMsgCount, this.roomIdsValue.length);
  }

  #updateCount(element, value = null) {
    let count = element.querySelector(".msg_count");

    if (count) {
      count.textContent = value ?? Number.parseInt(count.textContent) + 1;
      return;
    }

    count = countElCreate();

    if (value !== null) {
      count.textContent = value;
    }

    element.appendChild(count);
  }

  #handleActiveRoom(roomId, scroll) {
    if (scroll) {
      this.#scrollToBottom();
    }

    void this.#markMessagesAsRead(roomId);
  }

  async #markMessagesAsRead(roomId) {
    try {
      await fetch("/messages/read_message", {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          room_id: roomId
        })
      });
    } catch (error) {
      console.error("Failed to mark messages as read:", error);
    }
  }

  #moveConversationToTop(roomId) {
    const element = document.getElementById(`update_conversation_${roomId}`);
    const parent = element?.closest(".conversation-list");

    parent?.prepend(element);
  }

  #findRoomTarget(roomId) {
    return this.listTargets?.find(roomTarget => roomTarget.dataset.roomId == roomId);
  }

  #scrollToBottom() {
    const messages = document.querySelector("#chat-history");
    if (!messages) return;

    requestAnimationFrame(() => {
      messages.scrollTop = messages.scrollHeight;
    });
  }
}
